import { create } from "zustand";

const ZustandProductCgi = create((set, get) => ({
  valorEmprestimo: "",
  prazoMesesCgi: 0,
  cgi: "FIN",
  valorImovelCgi: "",
  valorEmprestimoIsErro: false,
  prazoMesesCgiIsErro: false,
  valorDoImovelCgiIsErro: false,
  imovelCgiIsErro: false,

  setPrazoMesesCgi: (value) => set({ prazoMesesCgi: parseFloat(value) || 0 }),
  setValorImovelCgi: (value) => set({ valorImovelCgi: parseFloat(value) || 0 }),
  setCgi: (value) => set(() => ({ cgi: value || "" })),
  setValorEmprestimo: (value) => set({ valorEmprestimo: parseFloat(value) || 0 }),
  setValorEmprestimoIsErro: (value) => set({ valorEmprestimoIsErro: value }),
  setValorDoImovelCgiIsErro: (value) => set({ valorDoImovelCgiIsErro: value }),
  setPrazoMesesCgiIsErro: (value) => set({ prazoMesesCgiIsErro: value }),


  setImovelCgiIsErro: (value) => set({imovelCgiIsErro: value})

}));

export default ZustandProductCgi;
